/* eslint-disable max-lines */
import WarningMsg from 'components/WarningMsg';
import React, { useEffect } from 'react';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  getCompareMode,
  getOriginalActiveLanguageMatcher,
  getShouldDisableEdit,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import UserNotificationMsgs from 'utils/userNotificationMsgs';
import ChooseCombinationType from '../ChooseCombinationType';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';

type LanguageMatcherType = {
  isSaved: boolean;
};

const LanguageMatcherForm: React.FC<LanguageMatcherType> = ({ isSaved }) => {
  const unsaved = useSelector(unsavedChanges);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  // Keep selectors for consistent disabling/focus behavior (header reads them too)
  useSelector(getOriginalActiveLanguageMatcher);
  useSelector(getCompareMode);
  useSelector(getShouldDisableEdit);

  useEffect(() => {
    if (activeLanguageMatcher && activeLanguageMatcher.isNew) {
      const input = document.getElementById('name');
      input?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLanguageMatcherId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={UserNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>
      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader />

        <div className="mt-6 flex pt-4 justify-between">
          <div className="w-full">
            <ChooseCombinationType activeLanguageMatcher={activeLanguageMatcher} />
          </div>
        </div>
        <div className="mt-auto pt-6 flex flex-row justify-end">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
      </div>
    </div>
  );
};

export default LanguageMatcherForm;
